// If a function is deprecated, add one of these functions to the function call.
// They're intended to help mark functions that are deprecated or moved, to support easy reuse
// They will only fire in dev environments.

const isDev = () => process.env.NODE_ENV === "development";

// Prints a warning that the current function is deprecated and shouldn't be used.
export const warnDeprecated = (recommendation: string = "") => {
  if (isDev()) {
    console.warn(`This function is deprecated. ${recommendation}`);
  }
};

// Prints a warning that the current function has been moved to @eave/shared
// Include the new location
// If it was renamed, include the new name in the `recommendation`
export const warnMovedToShared = (
  fnName: string,
  newLocation: string = "",
  recommendation: string = "Import the function from the new location instead.",
) => {
  if (isDev()) {
    console.warn(
      `The ${fnName} function has been moved to @eave/shared${
        newLocation === "" ? "" : `${newLocation}`
      }. ${recommendation}`,
    );
  }
};
